export abstract class ListUtil {
    public static clear(list: unknown[]): boolean {
        if (list && list.length > 0) {
            while (list.length > 0) {
                list.pop();
            }
            return true;
        }
        return false;
    }

    public static isEmpty(list: unknown[] | null | undefined): boolean {
        return null == list || undefined == list || list.length == 0;
    }

    public static isNotEmpty(list: unknown[] | null | undefined): boolean {
        return !this.isEmpty(list);
    }
}
